export default {
  yellow: (s) => s,
}
